module.exports = __webpack_public_path__ + "static/media/ImporterIcon.d281f01c.svg";